export const TOOLTIP_DELAY_PROPS = {
  open: 400,
}
